import { Box, Typography } from "@mui/material";
import React from "react";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { useTranslation } from 'react-i18next';

const NoDataText = () => {
	const { t } = useTranslation();
	return (
		<Box display="flex" alignItems="center" flexDirection="column" justifyContent="center" gap={1} color={"#ddd"}>
			<EqualizerIcon sx={{ fontSize: "70px" }} />
			<Typography variant="h5" fontWeight={"500"}>
				{t('DATE_RANGES.QUERY_RETURNED_NO_DATA')}
			</Typography>
		</Box>
	);
};

export default NoDataText;
